import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Shield, Flag } from 'lucide-react';
import { ReportButton } from '@/components/ReportButton';

interface MobileSafetyTipsProps {
  tips?: string[];
}

export function MobileSafetyTips({ tips }: MobileSafetyTipsProps) {
  const items = tips ?? [
    "Don't pay any advance without verifying",
    'Meet the seller at a safe public place',
    'Verify the property documents before paying',
  ];
  return (
    <Card className="bg-muted/40">
      <CardContent className="p-4">
        <div className="flex items-start gap-2">
          <Shield className="h-5 w-5 text-primary shrink-0 mt-0.5" />
          <div>
            <div className="font-semibold text-sm mb-1.5">Safety Tips</div>
            <ul className="text-xs text-muted-foreground space-y-1">
              {items.map((tip, i) => (
                <li key={i}>• {tip}</li>
              ))}
            </ul>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

interface MobileUsefulLinksProps {
  links: { label: string; to: string }[];
}

export function MobileUsefulLinks({ links }: MobileUsefulLinksProps) {
  if (!links.length) return null;
  return (
    <Card>
      <CardContent className="p-4">
        <div className="text-xs font-bold uppercase tracking-wider text-muted-foreground mb-3">
          Useful Links
        </div>
        <div className="space-y-2">
          {links.map((l, i) => (
            <Link
              key={i}
              to={l.to}
              className="block text-sm text-primary hover:underline"
            >
              {l.label}
            </Link>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}

interface MobileReportListingProps {
  targetType: 'property' | 'plot' | 'project';
  targetId: string;
  label?: string;
}

export function MobileReportListing({ targetType, targetId, label = 'Report this listing' }: MobileReportListingProps) {
  return (
    <Card className="bg-muted/40">
      <CardContent className="p-3">
        <ReportButton
          targetType={targetType}
          targetId={targetId}
          variant="outline"
          className="w-full border-destructive/30 text-destructive hover:bg-destructive hover:text-destructive-foreground font-semibold text-sm"
          label={label}
        />
      </CardContent>
    </Card>
  );
}
